import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";

const API_URL = process.env.REACT_APP_BASE_URL;
const TOKEN = "a94c7ac0083ae190f0fe61143a7547799b5334c4";

const headers = {
  Authorization: `Token ${TOKEN}`,
  "Content-Type": "application/json",
};


export const fetchProcessorRamChannelKitAttributes = createAsyncThunk(
  "processor_ram_channel_kit/fetchProcessorRamChannelKitAttributes",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      
      if (filters && filters.length > 0) {
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (
              filterField &&
              filterValue !== undefined &&
              filterValue !== null
            ) {
              // For date filters
              if (
                typeof filterValue === "object" &&
                (filterValue.from_date || filterValue.to_date)
              ) {
                if (filterField === "created_at") {
                  if (filterValue.from_date) {
                    params.append(
                      "created_at_date_from",
                      String(filterValue.from_date)
                    );
                  }
                  if (filterValue.to_date) {
                    params.append(
                      "created_at_date_to",
                      String(filterValue.to_date)
                    );
                  }
                }

                if (filterField === "updated_at") {
                  if (filterValue.from_date) {
                    params.append(
                      "updated_at_date_from",
                      String(filterValue.from_date)
                    );
                  }
                  if (filterValue.to_date) {
                    params.append(
                      "updated_at_date_to",
                      String(filterValue.to_date)
                    );
                  }
                }
              } else {
                // For normal filters (string/number)
                params.append(filterField, String(filterValue));
              }
            }
          }
        );
      }

      const response: any = await Axios.get(`api/attributes/ram-channel-kit/list/?${params.toString()}`);
      // const response: any = await Axios.get(`/district/`, {
      //   params: {
      //     page,
      //     page_size: pageSize,
      //     search: search || undefined,
      //     filters: filters ? JSON.stringify(filters) : undefined,
      //   },
      // });

      // response.data;
      return {
        data: response.data.data || [],
        rowCount: response.data.count || 0,
      };
    } catch (error: any) {
      console.error(
        "fetchPackages error:",
        error.response?.data || error.message
      );
      throw new Error("Failed to fetch category");
    }
  }
);

export const fetchProcessorRamChannelKitById = createAsyncThunk(
  "processor_ram_channel_kit/fetchProcessorRamChannelKitById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(`api/attributes/ram-channel-kit/${id}/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch RAM Channel Kit by ID"
      );
    }
  }
);

export const fetchProcessorRamChannelKitByDropDown = createAsyncThunk(
  "processor_ram_channel_kit/fetchProcessorRamChannelKitByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/category/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch Category list"
      );
    }
  }
);
export const updateProcessorRamChannelKit = createAsyncThunk(
  "processor_ram_channel_kit/updateProcessorRamChannelKit",
  async ({ id, payload }: { id: string; payload: any }, { rejectWithValue }) => {
    try {
      const response: any = await Axios.put(
        `api/attributes/ram-channel-kit/${id}/`,
        payload
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to update RAM Channel Kit"
      );
    }
  }
);

export const updateStatusInProcessorRamChannelKit = createAsyncThunk(
  "processor_ram_channel_kit/updateStatusInProcessorRamChannelKit",
  async (categoryData: any, { rejectWithValue }) => {
    try {
      const payload = { is_active: categoryData.is_active };
      const response: any = await Axios.patch(
        `api/ram-channel-kit/${categoryData.id}/update/`,
        payload
      );
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to update status in category"
      );
    }
  }
);

export const addProcessorRamChannelKit= createAsyncThunk(
  "processor_ram_channel_kit/addProcessorRamChannelKit",
  async (categoryData: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(
        `api/attributes/ram-channel-kit/create/`,
        categoryData
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to add category");
    }
  }
);

export const deleteGp = createAsyncThunk(
  "category/delete",
  async (id: number, { rejectWithValue }) => {
    try {
      await Axios.delete(`/category/${id}/`);
      return id;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// export const exportCategoryCSV = async () => {
//   const response = await Axios.get("/category/?export=csv", {
//     responseType: "blob",
//   });

//   return {
//     blob: response.data,
//     filename:
//       response.headers["content-disposition"]
//         ?.split("filename=")[1]
//         ?.replace(/"/g, "") || "category.csv",
//   };
// };
export const exportProcessorCorsCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(
      ({
        filterField,
        filterValue,
      }: {
        filterField: string;
        filterValue: any;
      }) => {
        if (filterField && filterValue !== undefined && filterValue !== null) {
          if (typeof filterValue === "object" && filterValue !== null) {
            Object.entries(filterValue).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                params.append(key, String(value));
              }
              if (
                (filterValue.from_date || filterValue.to_date) &&
                (filterField === "created_at" || filterField === "updated_at")
              ) {
                if (filterField === "created_at") {
                  filterField = "created";
                } else {
                  filterField = "updated";
                }
                params.append("filter_by", filterField);
              }
            });
          } else {
            params.append(filterField, filterValue);
          }
        }
      }
    );
  }

  const response = await Axios.get(`api/attributes/ram-channel-kit/list/?${params.toString()}`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "category.csv",
  };
};
